<template>
    <div
        ref="panel"
        class="panel">
        <div
            class="commodity-panel-area"
            v-if="consumerCommodities.length >= 0">
            <div class="commodity-paragraph-title">
                用户下单商品：
                <a-icon
                    v-on:click="fastConfirm"
                    class="fast-confirm"
                    theme="twoTone"
                    type="check-circle" />
            </div>

            <div id="purchased-commodity-area">
                <div class="commodity-grid">
                    <div
                        v-for="item in consumerCommodities"
                        :key="item.id">
                        <Commodity
                            :item="item"/>
                    </div>
                </div>
            </div>

            <div class="commodity-paragraph-title">
                货柜商品：
            </div>

            <div id="commodity-area">
                <div class="commodity-grid">
                    <div
                        v-for="item in cupboardCommodities"
                        :key="item.id">
                        <Commodity :item="item"/>
                    </div>
                </div>
            </div>

            <div class="bottom-padding-area"/>
        </div>
        <div
            class="commodity-panel-area"
            v-else>
        </div>

        <div
            v-if="commmodityThumbnailIsShow"
            v-on:click="hideCommodityThumbnail"
            class="commodity-thumbnail-area">
            <div
                v-for="image in commodityThumbnailImages"
                :key="image">
                <img
                    class="thumbnail-image"
                    :src="image"/>
            </div>
        </div>

        <div
            v-if="consumerCommodities.length >= 0"
            class="bottom-area">
            <div class="rest-button-area">
                <div>
                 <a href="#" class="send-rollback-button"  v-on:click="sendRollbackClick">撤销上一单（10秒内）</a>
                </div>
                <div>
                  <a-popconfirm
                      title="确定设备故障？"
                      ok-text="确定"
                      cancel-text="取消"
                      @confirm="sendExceptionClick"
                      @cancel="sendExceptionCancel"
                  >
                    <a href="#" class="send-exception-button">设备故障</a>
                  </a-popconfirm>
                </div>
                <a-checkbox
                    :checked="restMoment"
                    class="rest-button"
                    @change="restCheck">
                    停止接单
                </a-checkbox>
            </div>
            <div class="button-area">
                <ExceptionButton/>
                <ConfirmButton/>
            </div>
        </div>
    </div>
</template>

<script>
 import Vue from 'vue';
 import Commodity from "./Commodity.vue"
 import EventBus from '../event/event-bus.js';
 import ConfirmButton from "./ConfirmButton.vue"
 import ExceptionButton from "./ExceptionButton.vue"
 import Checkbox from "ant-design-vue/lib/checkbox/Checkbox";
 import Popconfirm from "ant-design-vue/lib/popconfirm"
 import { confirmOrder } from "../util/order.js"
 import message from "ant-design-vue/lib/message";
 import {sendException} from "@/util/order";
 import {sendRollback} from "@/util/order";

 Vue.component(Checkbox.name, Checkbox);
 Vue.component(Popconfirm.name, Popconfirm);
 export default {
     name: 'CommodityPanel',
     data() {
         return {
             clickThumbnailArea: false,
             commmodityThumbnailIsShow: false,
             commodityThumbnailImages: []
         }
     },
     props: {
     },
     components: {
         Commodity,
         ExceptionButton,
         ConfirmButton
     },
     created() {
         console.log("Create CommodityPanel")
     },
     mounted() {
         console.log("Mount CommodityPanel")

         EventBus.$on("showCommmodityThumbnail", this.showCommmodityThumbnail)
         EventBus.$on("fastConfirm", this.fastConfirm)
     },
     beforeDestroy() {
         EventBus.$off("showCommmodityThumbnail")
         EventBus.$off("fastConfirm")
     },
     computed: {
         restMoment: {
             get() { return this.$store.getters.restMoment },
             set(value) { this.$store.commit('updateRestMoment', value ) }
         },
         consumerCommodities: {
             get() { return this.$store.getters.orderConsumerCommodities },
             set(value) { this.$store.commit('changeOrderConsumerCommodities', value ) }
         },
         cupboardCommodities: {
             get() { return this.$store.getters.orderCupboardCommodities },
             set(value) { this.$store.commit('changeOrderCupboardCommodities', value ) }
         }
     },
     methods: {
         hideCommodityThumbnail() {
             this.commmodityThumbnailIsShow = false
             this.commodityThumbnailImages = []
         },

         showCommmodityThumbnail(thumbnailImages) {
             this.commmodityThumbnailIsShow = true
             this.commodityThumbnailImages = thumbnailImages
         },
         restCheck(e) {
             this.$store.commit("updateRestMoment", e.target.checked)
         },
         sendRollbackClick() {
           console.log("sendRollbackClick")
           sendRollback(this.$store.getters.orderId)
         },
          sendExceptionClick() {
            console.log("sendExceptionClick")
            sendException(this.$store.getters.orderId)
         },
          sendExceptionCancel(e) {
            console.log("sendExceptionCancel")
         },
         fastConfirm() {
             console.log("Fast confirm")

             if (Object.keys(this.$store.getters.shoppingCommodities).length > 0) {
                 message.error("你已经选择了商品，应该点击右下角的按钮")
             } else {
                 var orderCommodities = this.$store.getters.orderConsumerCommodities
                 if (orderCommodities.length == 0) {
                   message.error("未取货时，应该点击右下角的按钮")
                   return
                 }
                 var commodites = {}

                 for (var i = 0; i < orderCommodities.length; i++) {
                     commodites[orderCommodities[i].id] = {
                         number: orderCommodities[i].amount
                     }
                 }

                 confirmOrder(
                     this.$store.getters.orderId,
                     commodites,
                     function() {
                         EventBus.$emit("fetchNextOrder")
                     }
                 )
             }
         }
     }
 }
</script>

<style scoped>
 .panel {
     width: 530px;
     height: 100%;
     background-color: #FFF;

     overflow-y: scroll;

     position: relative;
 }

 .panel::-webkit-scrollbar {
     display:none
 }

 .commodity-paragraph-title {
     margin-top: 15px;
     margin-bottom: 5px;
     margin-left: 0px;
     font-size: 16px;
     color: #333333;
     user-select: none;

     position: relative;
 }

 #purchased-commodity-area {
     width: 100%;
 }

 .commodity-grid {
     display: grid;
     grid-template-columns: 100px 100px 100px 100px 100px;
     margin-top: 10px;
     margin-bottom: 10px;
     padding-left: 5px;
 }

 .commodity-panel-area {
     width: 100%;
     height: 100%;
     overflow-y: auto;

     padding-left: 10px;
     padding-right: 10px;
 }

 .bottom-padding-area {
     height: 107px;
 }

 .bottom-area {
     border-top: 1px solid #DDD;
     background-color: #FFF;

     box-shadow: 0px -5px 10px -10px #858484;

     position: fixed;
     bottom: 0;
     width: 530px;
     height: 107px;
 }

 .rest-button-area {
     display: flex;
     flex-direction: row;
     justify-content: flex-end;
     padding-top: 10px;
     padding-bottom: 5px;
     padding-right: 5px;
 }

 .button-area {
     padding-top: 5px;
     padding-bottom: 10px;
     padding-left: 10px;
     padding-right: 10px;
     display: flex;
     flex-direction: row;
     align-items: center;
     justify-content: center;
 }

 .commodity-thumbnail-area {
     position: absolute;
     top: 0;
     bottom: 0;
     left: 0;
     right: 0;
     background-color: rgba(0, 0, 0, 0.9);
     z-index: 2000;

     display: flex;
     flex-direction: column;
     align-items: center;

     overflow-y: scroll;

     padding-top: 5px;
     padding-bottom: 5px;
 }

 .thumbnail-image {
     margin: 10px;
     user-select: none;
 }

 .fast-confirm {
     position: absolute;
     top: 0;
     right: 0;
     cursor: pointer;
     font-size: 24px;
 }

 .send-exception-button {
   color: #FFFFFF;
   background-color: #D80E3B;
   border-radius: 5px;
   padding-left: 10px;
   padding-right: 10px;
   padding-top: 2px;
   padding-bottom: 2px;
   margin-left: 5px;
   margin-right: 10px;
   text-align: center;
   cursor: pointer;
 }

 .send-rollback-button {
   color: #FFFFFF;
   background-color: #F3C246;
   border-radius: 5px;
   padding-left: 10px;
   padding-right: 10px;
   padding-top: 2px;
   padding-bottom: 2px;
   margin-left: 5px;
   margin-right: 10px;
   text-align: center;
   cursor: pointer;
 }

</style>
